import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fixBundleDiscrepancies,
  FixItem,
} from "../services/fix-bundle-discrepancies";

export function useFixBundleDiscrepancies() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (fixes: FixItem[]) => fixBundleDiscrepancies(fixes),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bundle-discrepancies"] });
    },
  });
}
